/**
 * Centralized API error codes and helpers.
 *
 * Backend error body shapes:
 * - Standard (buildResponseError): `{ entityId, errorId, message, metadata }`
 * - Raw auth 401 from `verifyAndDecodeJwt` preHandler (NO errorId):
 *   - `{ errorCode: "JWT_MISSING", message: "Missing token" }` (no cookie)
 *   - `{ errorCode: "JWT_INVALID", message: "Invalid JWT" }` (invalid/expired cookie)
 * - Legacy auth 401 (pre a099bcd): `{ errorCode: "TOKEN_INVALID", ... }`
 */

export const AUTH_ERROR_CODES = {
	TOKEN_INVALID: "TOKEN_INVALID",
	JWT_MISSING: "JWT_MISSING",
	JWT_INVALID: "JWT_INVALID",
};

export const NO_PERMISSION = "NO_PERMISSION";

/**
 * Extracts the error code from an API error body, tolerating both shapes:
 * raw auth bodies (`errorCode`) and buildResponseError bodies (`errorId`).
 * @param {Record<string, unknown> | null | undefined} response
 * @returns {string | null}
 */
export function getErrorCode(response) {
	return response?.errorCode ?? response?.errorId ?? null;
}

/**
 * @param {string | null} code
 * @returns {boolean}
 */
export function isAuthErrorCode(code) {
	return Object.values(AUTH_ERROR_CODES).includes(code);
}

/**
 * @param {Record<string, unknown> | null | undefined} response
 * @returns {boolean}
 */
export function isNoPermission(response) {
	return getErrorCode(response) === NO_PERMISSION;
}
